import { combineReducers } from '@reduxjs/toolkit';
import { mapFiltersSlice } from './map/filters';
import { userAuthSlice } from './user/userAuth';

export const rootReducer = combineReducers({
  userAuth: userAuthSlice.reducer,
  mapFilters: mapFiltersSlice.reducer,
});
